import { UPDATE_FIELD, SET_LIST, CLEAR } from "./Actions";

const defaultState = {
  list: null,
  single: null,
  load: false,
  type: null,
  filters: {},
  meta: null,
  lastPage: 0,
  page: 1,
  from: 1,
  to: 10,
  total: 0,
  perPage: 15,
  searchKey: "",
};

const listReducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [payload.prop]: payload.value,
      };
    case SET_LIST:
      return {
        ...state,
        list: payload.list,
        lastPage: payload.lastPage,
        type: payload.type,
        perPage: payload.perPage,
        total: payload.total,
        page: payload.page,
        from: payload.from,
        to: payload.to,
        meta: payload.meta,
      };
    case CLEAR:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
};

export default listReducer;
